import {
  Body,
  getImgProps,
  Heading,
  Img,
  Label,
  Markdown,
  TextVerticalSpacer,
  VerticalSpacer,
} from '@superhi/design'
import React from 'react'

type Props = {
  title: string
  description: string
  header: React.ReactElement
  position: number
}

const MARKDOWN_1_OVERRIDES = {
  p: ({ children }: any) => <Body level="3">{children}</Body>,
}

const SyllabusProject: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  description,
  header,
  position,
}) => (
  <VerticalSpacer amount={{ small: 16, medium: 16, large: 24 }}>
    <div>{header}</div>

    <TextVerticalSpacer level="4">
      <Label level="2" color="GREY_70">
        Chapter {position}
      </Label>
      <Heading level="4" as={'h3'}>
        {title}
      </Heading>

      <Markdown overrides={MARKDOWN_1_OVERRIDES}>{description}</Markdown>
    </TextVerticalSpacer>
  </VerticalSpacer>
)

export default SyllabusProject
